module.exports = __webpack_public_path__ + "static/media/square.5cf7fd3a.jpg";